import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Tr } from '@chakra-ui/react';

export default function SortableRow({ id, children }: any) {
  const sortable = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(sortable.transform),
    transition: sortable.transition,
    opacity: sortable.isDragging ? 0.6 : 1
  };

  return (
    <Tr ref={sortable.setNodeRef} style={style}>
      {children(sortable)}
    </Tr>
  );
}
